import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'wonderbly-components/lib/Panel';
import Icon from 'wonderbly-components/lib/Icon';
import { LoadComponent } from '../Loading';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import PaymentButton from './PaymentButton';
import './PaymentMethods.scss';

const PaymentMethods = props => {
  const orderIsReady = !props.orderIsPending && !props.hasOrderFailed;
  return (
    <section className="payment-methods main-content">
      <Panel>
        <div className="payment-methods__header">
          <h5 className="payment-methods__title text-kilo">{props.title}</h5>
          <hr />
          {props.description &&
            <div className="payment-methods__description">
              <Icon icon="lock" /> {props.description}
            </div>
          }
        </div>
        <LoadComponent isLoading={props.orderIsPending || props.paymentMethods.isLoading} className="payment-methods__loading" relative dark small>
          {orderIsReady && props.items.map(method => {
            const methodType = method.paymentMethodType;
            return (
              <PaymentButton
                key={methodType}
                {...method.primary}
                method={methodType}
                disabled={!!props.submittingMethod}
                order={props.order}
                settings={props.settings && props.settings[methodType]}
                submittingMethod={props.submittingMethod}
                setSubmittingMethod={props.setSubmittingMethod}
              />
            );
          })}
        </LoadComponent>
      </Panel>
      {props.ctaLink && props.ctaText &&
        <div className="back-link-wrapper">
          <a href={localiseUrl(props.country, props.ctaLink)} className="back-to-link">
            {props.ctaText}
          </a>
        </div>
      }
    </section>
  );
};

PaymentMethods.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  orderIsPending: PropTypes.bool.isRequired,
  hasOrderFailed: PropTypes.bool.isRequired,
  submittingMethod: PropTypes.string,
  setSubmittingMethod: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  paymentMethods: PropTypes.object.isRequired,
  settings: PropTypes.object,
  items: PropTypes.arrayOf(PropTypes.shape({
    paymentMethodType: PropTypes.string.isRequired,
    primary: PropTypes.object,
  })).isRequired,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  country: PropTypes.object,
};

export default PaymentMethods;



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/PaymentMethods.js